import { apiUrl } from '../config';

/**
 * @param {string} id 数字身份证，每次请求必带
 * @param {number[]} [answers] 选项编号（int），无答题时不传
 */
export async function fetchQuestion(id, answers = []) {
  const params = new URLSearchParams();
  params.set('id', id);
  answers.forEach((value) => params.append('answer', String(value)));

  const url = apiUrl(`/api/interview/question?${params.toString()}`);
  const response = await fetch(url);

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || `请求失败 (${response.status})`);
  }

  return response.json();
}
